module.exports = __webpack_public_path__ + "static/media/inf_05pog06p.f5abe1a8.mp3";